import { platformData } from "./platform-data";
export var platformListResults = function (result) {
  var _a = platformData(result).list,
    list = _a === void 0 ? {
      meta: {
        count: 0,
        total: 0
      },
      results: []
    } : _a;
  return list.results;
};